import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { employeeAllocationApi, moneyUnitApi } from '../../../../services/apis';
import { validation, validateForm } from '../../../../utils/validation';
import {
  returnMiladiDateByStandardFormat,
  returnFlightDate,
  getDayDiff,
} from '../../../../utils/utility/booking';
import {
  CreditCard,
  RadioButton,
  Input,
  Button,
  DatePicker,
  Dropdown,
  Confirmation,
  Modal,
  ValidationMessage,
  Toast,
} from '../../../../component';
import './employeeCredit.scss';

const INITIAL_DATA = {
  id: '',
  expireDate: '',
  amount: 0,
  ceilingPurchase: 0,
  employeeAllocationStatusId: '1',
  profileId: 0,
  currencyId: 0,
  period: 0,
};

class EmployeeCredit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: structuredClone(INITIAL_DATA),
      currencyList: [],
      alertType: '',
      alertMessage: 'profilecredit.creditadd',
      toastState: '',
      alertBody: '',
      isShowAlert: false,
      toast: false,
    };
  }

  async componentDidMount() {
    let { data } = this.state;
    data.profileId = this.props.profileId;
    try {
      const {
        payload: { data },
        status,
      } = await moneyUnitApi.getAll();
      if (status === 200) {
        this.setState({ currencyList: data });
      }
    } catch (error) {
      this.setState({
        toast: true,
        data,
        alertMessage: 'booking.servererror',
        toastState: 'danger',
      });
    }
  }

  insert = async () => {
    const { data } = this.state;
    let today = new Date().toISOString(),
      SelectedDate = new Date(data.expireDate).toISOString();
    data.period = getDayDiff(today, SelectedDate);
    this.setState({ loading: true });
    try {
      await employeeAllocationApi
        .insert({ data })
        .then(({ status }) => {
          if (status === 200) {
            let data = structuredClone(INITIAL_DATA);
            delete data.expireDate;
            this.setState({
              data: structuredClone(INITIAL_DATA),
              toast: true,
              alertMessage: 'profilecredit.creditadd',
              toastState: 'success',
              errors: [],
            });
          }
        })
        .catch(() => {
          this.setState({
            toast: true,
            alertMessage: 'profilecredit.creditadderror',
            toastState: 'danger',
            errors: [],
          });
        })
        .finally(() => this.setState({ loading: false, errors: [] }));
    } catch (error) {
      console.log(error);
    }
  };

  update = async () => {
    const { data } = this.state;

    let today = new Date().toISOString(),
      SelectedDate = new Date(data.expireDate).toISOString();

    data.period = getDayDiff(today, SelectedDate);
    this.setState({ loading: true });
    try {
      await employeeAllocationApi
        .update({ data })
        .then(({ status }) => {
          if (status === 200) {
            let data = structuredClone(INITIAL_DATA);
            delete data.expireDate;
            this.setState({
              data,
              toast: true,
              alertMessage: 'profilecredit.creditadd',
              toastState: 'success',
              errors: [],
            });
          }
        })
        .catch((err) => {
          if (
            err.errMessage ===
            'There is already an active allocation for this profile'
          )
            this.setState({
              toast: true,
              alertMessage: 'profilecredit.creditadderror',
              toastState: 'danger',
              errors: [],
            });
        })
        .finally(() => this.setState({ loading: false, errors: [] }));
    } catch (error) {
      console.log(error);
    }
  };

  validate = () => {
    const { expireDate, currencyId, amount, ceilingPurchase } = this.state.data;
    const { error, result } = validateForm({
      amount: validation
        .number(amount.toString().replaceAll(',', ''))
        .required().errors,
      ceilingPurchase: validation
        .number(ceilingPurchase.toString().replaceAll(',', ''))
        .required().errors,
      expireDate: validation.required(expireDate).errors,
      currencyId: validation.required(currencyId).errors,
    });
    return { result, error };
  };

  inputHandleChange = (event) => {
    const { name, value } = event.target || event.currentTarget;
    const { errors, data } = this.state;
    if (value !== 0) {
      this.setState(
        { data: { ...data, [name]: parseInt(value.replaceAll(',', '')) } },
        () => {
          this.setState({
            errors: {
              ...errors,
              [name]: this.validate().error?.[name],
            },
          });
        },
      );
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target || event.currentTarget;
    const { errors, data } = this.state;
    if (value) {
      this.setState({ data: { ...data, [name]: value } }, () => {
        this.setState({
          errors: {
            ...errors,
            [name]: this.validate().error?.[name],
          },
        });
      });
    }
  };
  formatNumber = (num) => {
    if (typeof num === 'number' && !isNaN(num) && num !== 0) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return '';
  };

  // ShowCreditCard = () => {
  //   const {
  //     firstName,
  //     lastName,
  //     createdAt,
  //     language: { name },
  //   } = this.props;
  //   return (
  //     <CreditCard>
  //       <div
  //         className={`credit-card-data d-flex flex-column justify-content-between font-weight-bold h-100 text-white p-4 `}
  //       >
  //         <div
  //           className="flex-box-between d-flex justify-content-between align-items-center employee-credit-number"
  //           dir="ltr"
  //         >
  //           <div className="text-center">
  //             <FormattedMessage id="profile.creditBalance" />
  //             <div>
  //               <FormattedMessage id="booking.toman" />
  //               <span className="px-1">0</span>
  //             </div>
  //           </div>
  //           <FormattedMessage id="profile.employeeCredit" />
  //         </div>
  //         <div className="flex-box-between d-flex justify-content-between align-items-center">
  //           <div>{returnFlightDate(createdAt, name, false)}</div>
  //           <div>
  //             {firstName} {lastName}
  //           </div>
  //         </div>
  //       </div>
  //     </CreditCard>
  //   );
  // };

  render() {
    const {
        isShowAlert,
        alertType,
        alertBody,
        toast,
        alertMessage,
        toastState,
        data,
        currencyList,
        errors,
        loading,
      } = this.state,
      { intl } = this.props,
      { direction } = this.props.language,
      { employeeAllocationStatusId } = this.state.data;
    return (
      <>
        <Toast
          isOpen={toast}
          onClose={() => this.setState({ toast: false })}
          state={toastState}
          position="bottom"
          message={intl.formatMessage({
            id: alertMessage,
          })}
          direction={direction}
        />
        {isShowAlert && (
          <Confirmation
            isConfirmation={false}
            onReject={() => this.setState({ isShowAlert: false })}
            show={isShowAlert}
            type={alertType}
            closeTime={2000}
            body={intl.formatMessage({ id: alertBody })}
            defaultDescription={intl.formatMessage({ id: alertBody })}
            title={intl.formatMessage({ id: alertBody })}
          />
        )}
        <div className="employee-credit-container d-flex flex-column px-0">
          <div className="col-12 px-0 d-flex flex-xs-row flex-column mb-sm-0 mb-sm-4 mb-3 pb-3">
            <div className="flex-grow-1 invite-form-container col-md-6 col-xs-7 col-12 px-md-3 px-0 d-flex flex-row justify-content-center align-items-center ">
              <div
                className="h-100 d-flex flex-row justify-content-start pt-md-2 pt-0"
                style={{ width: '20rem' }}
              >
                <img
                  className="img-fluid default-border-radius-small h-auto img-setup"
                  alt=""
                  src={require('../../../../content/images/elements/increase-credit.png')}
                />
              </div>
            </div>
            <div className="col-md-6 col-xs-5 col-12 px-md-3 px-xs-1 px-3 pt-xs-0 pt-3 d-flex flex-column justify-content-start align-items-start">
              <span className="text-primary pt-md-4 pt-sm-4 pt-2 font-sm-xxlarge font-normal text-nowrap">
                <FormattedMessage id="profile.increaseCredit" />
              </span>
              <p className="col-md-10 col-12 text-third text-start pt-md-4 pt-1 px-0">
                <span className="font-sm-small font-xs-xsmall font-msmall lineHeight">
                  <FormattedMessage id="profile.textIncrease" />
                </span>
              </p>
            </div>
          </div>
          <div className="d-flex employee-credit-body d-flex justify-content-between pt-0 pb-3 px-0">
            <div className="col-12 px-0 d-flex flex-row  justify-content-end  flex-wrap">
              <div
                className={`d-flex w-100 flex-row flex-wrap align-items-center justify-content-between pt-0 ${
                  direction !== 'rtl' && 'pt-xs-3'
                }`}
              >
                <div className="col-sm-6 col-12 d-flex justify-content-start flex-column pb-sm-4 pb-2">
                  <Input
                    name="amount"
                    themeMode="light"
                    outSideLabelClass="text-start"
                    outSideLabelPosition="top"
                    label={intl.formatMessage({
                      id: 'profile.creditAmount',
                    })}
                    value={
                      !isNaN(data?.amount) && data?.amount !== 0
                        ? String(data?.amount).replace(
                            /(.)(?=(\d{3})+$)/g,
                            '$1,',
                          )
                        : null
                    }
                    type="text"
                    className="w-100 wallet"
                    tabIndex="1"
                    onChange={this.inputHandleChange}
                    outSideLabel={true}
                    inputClassName={
                      'font-normal height-input-profile px-sm-3 px-3'
                    }
                  />
                  <ValidationMessage errors={errors?.amount} />
                </div>
                <div className="col-sm-6 col-12 d-flex flex-column justify-content-start pb-sm-4 pb-3">
                  <Input
                    name="ceilingPurchase"
                    themeMode="light"
                    outSideLabelClass="text-start"
                    outSideLabelPosition="top"
                    label={intl.formatMessage({
                      id: 'profile.theCeilingOfEachPurchase',
                    })}
                    value={this.formatNumber(data?.ceilingPurchase)}
                    type="text"
                    className="w-100 wallet"
                    tabIndex="2"
                    onChange={this.inputHandleChange}
                    outSideLabel={true}
                    inputClassName={
                      'font-normal height-input-profile px-sm-3 px-3'
                    }
                  />
                  <ValidationMessage errors={errors?.ceilingPurchase} />
                </div>
              </div>
              <div
                className={`d-flex w-100 flex-row flex-wrap align-items-center justify-content-between pt-0 ${
                  direction !== 'rtl' && 'pt-xs-3 pt-0'
                }`}
              >
                <div className="col-sm-6 col-12 d-flex flex-column justify-content-start pb-sm-0 pb-3">
                  <Dropdown
                    name="currencyId"
                    id="currencyId"
                    label="profile.currency"
                    value={data.currencyId}
                    options={{
                      data: currencyList,
                      label: 'moneyUnit',
                      value: '_id',
                    }}
                    onChange={this.handleChange}
                    outSideLabel={true}
                    withoutShadow={true}
                    iconNameDrp={null}
                    labelPosition="top"
                    theme="light"
                    maxHeight="55px"
                    outSideLabelClass={'dropDown-fontSize'}
                    classNames="bg-third-light height-55px"
                  />
                  <ValidationMessage errors={errors?.currencyId} />
                </div>
                <div className="col-sm-6 col-12">
                  <DatePicker
                    name={'expireDate'}
                    themeMode="light"
                    value={data.expireDate}
                    placeholder={intl.formatMessage({
                      id: 'profile.validityDuration',
                    })}
                    outSideLabelClassname={'dropDown-fontSize'}
                    className="mb-4"
                    inputClassName={'font-normal'}
                    onChange={(date) => {
                      this.handleChange({
                        target: {
                          value: returnMiladiDateByStandardFormat(date),
                          name: 'expireDate',
                        },
                      });
                    }}
                    outSideLabel={true}
                    withoutShadow={true}
                    maxHeight="55px"
                    heightSize="height-55px px-lg-0 px-3"
                  />
                  <ValidationMessage errors={errors?.expireDate} />
                </div>
              </div>
              <label className="credit-status pt-xs-4 pt-2 mt-3 m-0 d-flex flex-column justify-content-start align-items-start col-sm-6 col-12 px-3">
                <div className="px-2">
                  <FormattedMessage id="profile.creditStatus" />
                  <span className="px-2">:</span>
                </div>
                <div className="d-flex justify-content-start flex-fill pt-3 pb-sm-0 pb-2 text-nowrap">
                  <RadioButton
                    name="employeeAllocationStatusId"
                    label="profile.active"
                    inputClassName="font-weight-bold m-0"
                    checked={employeeAllocationStatusId === '1'}
                    onChange={this.handleChange}
                    value={'1'}
                  />
                  <RadioButton
                    name="employeeAllocationStatusId"
                    label="profile.disactive"
                    inputClassName="font-weight-bold m-0 px-2"
                    checked={employeeAllocationStatusId === '2'}
                    onChange={this.handleChange}
                    value={'2'}
                  />
                </div>
              </label>
              <div className="col-sm-6 col-12">
                <div className="d-flex justify-content-around pt-xs-5 pt-4 mt-sm-2 mt-0">
                  <Button
                    name={`insertCredit-data`}
                    id={`insertCredit-data`}
                    label={intl.formatMessage({
                      id: 'profile.increaseCredit',
                    })}
                    className="btn-secondary"
                    disabled={!this.validate().result || loading}
                    loading={loading}
                    onClick={() => (data.id ? this.update() : this.insert())}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(injectIntl(EmployeeCredit));
